module.exports = __webpack_public_path__ + "64eaa23f39324307297e93e01b375045.gif";